import * as settings from '../constants/settings';

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authorization && user.authorization.authToken) {
        return { 'Authorization': 'Bearer ' + user.authorization.authToken, 'Channel': settings.ONLINE_CHANNEL_KEY};
    } else {
        return { 'Channel': settings.ONLINE_CHANNEL_KEY};
    }
}

export function authApiHeader() {
    let appToken = JSON.parse(localStorage.getItem('appToken'));

    if (appToken && appToken.authorization.authToken) {
        return { 'Authorization': 'Bearer ' + appToken.authorization.authToken };
    }
}

export function clientIdHeader() {
    return { 'x-client-id': settings.CLIENT_HEADER};
}

export function authToken(){
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.authorization.authToken)
        return user.authorization.authToken;
}



// WEBPACK FOOTER //
// ./src/utils/auth-header.js